export default {
    FROM: {
        EXAM_PAYMENT: 'exam-payment',
    },
};
